<template>
  <div>
    <validation-observer
      v-if="dataItem.balance_amount === 0"
      ref="statusFormRules"
    >
      <div class="font-weight-bold text-primary">
        Durum
      </div>
      <div>
        <b-form-group>
          <v-select
            id="id_promissory_statuses"
            v-model="dataItem.id_promissory_statuses"
            :options="promissoryStatuses"
            placeholder="Durum"
            label="title"
            :reduce="item => item.id"
            :clearable="false"
            :selectable="option => isStatusSelectable(option)"
            @input="changeStatus"
          />
        </b-form-group>
      </div>
      <div v-if="dataItem.id_promissory_statuses === '3'">
        <b-form-group
          label-for="return_notes"
          label="İade Notu"
        >
          <b-form-textarea
            id="return_notes"
            v-model="dataItem.return_notes"
            placeholder="Çek & Senet İade Notu"
          />
        </b-form-group>
      </div>
      <div class="mt-1">
        <b-button
          variant="success"
          block
          :disabled="submitStatus"
          @click="submitForm"
        >
          <FeatherIcon icon="SaveIcon" />
          Durum Güncelle
        </b-button>
      </div>
    </validation-observer>
  </div>
</template>

<script>
import { ValidationObserver, localize } from 'vee-validate'
import { required } from '@validations'
import {
  BButton, BFormGroup, BFormTextarea,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import toastMixin from '@/libs/toast'

export default {
  name: 'StatusCard',
  components: {
    vSelect,
    BButton,
    BFormGroup,
    BFormTextarea,
    ValidationObserver,
  },
  mixins: [toastMixin],
  data() {
    return {
      required,
      submitStatus: false,
    }
  },
  computed: {
    dataItem() {
      return this.$store.getters['promissories/dataItem']
    },
    promissoryStatuses() {
      return this.$store.getters['promissoryStatuses/dataList']
    },
    saveData() {
      return this.$store.getters['accountActivities/dataSaveStatus']
    },
  },
  watch: {
    saveData(val) {
      if (val.status === true) {
        this.showToast({ template: 'saveSuccess' })
      } else if (val.status === false) {
        this.showToast({ template: 'saveError' })
      }
    },
  },
  created() {
    this.getPromissoryStatuses()
    localize('tr')
  },
  methods: {
    changeStatus() {
      if (this.dataItem.id_promissory_statuses !== '3') {
        this.dataItem.return_notes = ''
      }
    },
    submitForm() {
      this.$refs.statusFormRules.validate().then(success => {
        if (success) {
          this.submitStatus = true
          if (this.dataItem.id_promissory_statuses === '3') {
            this.dataItem.is_return = '1'
          } else {
            this.dataItem.is_return = '0'
          }
          this.$store.dispatch('promissories/saveData', this.dataItem)
            .then(response => {
              if (response) {
                this.submitStatus = false
              }
            })
        } else {
          this.showToast({ template: 'requireWarning' })
        }
      })
    },
    getPromissoryStatuses() {
      this.$store.dispatch('promissoryStatuses/getDataList')
    },
    isStatusSelectable(option) {
      // Kalan bakiye varsa "Ödendi" durumuna geçemesin
      if (
        Number(this.dataItem.balance_amount) > 0
          && option.id === '2'
      ) {
        return false
      }

      return true
    },
  },
}
</script>
